import React from 'react';
import Title from 'components/UI/Title';
import Badge from 'components/UI/Badge';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

function Alerts({ isB2cPage })
{
    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10 lg:tw-pl-[248px]">
            <div className="tw-flex tw-justify-between tw-items-center ">
                <div className="tw-flex tw-flex-col">
                    <Title
                        title="Alerts"
                    />
                </div>
            </div>

            <div className="tw-flex tw-flex-col tw-bg-white tw-rounded tw-p-3 tw-mt-6 tw-mb-9 dark:tw-bg-neutral-500">

                <Title before type="secondary" margin="tw-m-0" title=" " />

                <div className="tw-flex  tw-gap-5">
                    <div className="tw-flex tw-p-5 tw-flex-[4] tw-gap-4">
                        <div className="tw-w-64">
                            <div><h3 className="tw-text-base tw-text-neutral-darkest tw-font-bold dark:tw-text-neutral-300"> Filter by</h3></div>
                            <div className="tw-bg-primary-lightest tw-py-2 tw-px-6 dark:tw-bg-neutral-800 dark:tw-border-neutral-500"> <select className="tw-w-full tw-bg-transparent "> <option value="0">All</option> </select> </div>
                        </div>
                    </div>
                </div>

                <table className="tw-font-default tw-text-xs tw-font-bold tw-w-full">
                    <tbody>
                        <tr className="odd:tw-bg-neutral-lightest tw-relative tw-bg-[#CCCCCC] dark:odd:tw-bg-zinc-800 dark:tw-bg-zinc-700">
                            <td className="tw-py-5 tw-px-3 tw-text-center">Alert 1</td>
                            <td className="tw-py-5 tw-px-3 tw-text-center"><Badge className="tw-w-64">Unread</Badge></td>
                        </tr>

                        <tr className="odd:tw-bg-neutral-neutral tw-relative tw-bg-[#CCCCCC] dark:odd:tw-bg-zinc-500 dark:tw-bg-zinc-700">
                            <td className="tw-py-5 tw-px-3 tw-text-center">Alert 2</td>
                            <td className="tw-py-5 tw-px-3 tw-text-center"><Badge className="tw-bg-primary-lightest tw-w-64">Read</Badge></td>
                        </tr>
                    </tbody>
                </table>

            </div>

            <Helmet title={`Alerts | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Alerts" />
            </Helmet>

        </div>
    );
}

Alerts.defaultProps = {
    isB2cPage: false,
};

Alerts.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default Alerts;
